import { cn, hasMessage } from "@/lib/utils";
import { MutableRefObject, useEffect, useState } from "react";

import { useChatMessages } from "@chainlit/react-client";

import MessageComposer from "./MessageComposer";
import Starters from "./Starters";

interface Props {
  autoScrollRef: MutableRefObject<boolean>;
}

export default function WelcomeScreen(props: Props) {
  const { messages } = useChatMessages();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  if (hasMessage(messages)) return null;

  return (
    <div
      id="welcome-screen"
      className={cn(
        "flex flex-col gap-4 w-full flex-grow items-center justify-center welcome-screen mx-auto transition-opacity duration-500 opacity-0 delay-100",
        isVisible && "opacity-100"
      )}
    >
      <MessageComposer isWelcome {...props} />
      <Starters />
      <div className="disclaimer">
        Disclaimer: The information provided should be regarded as informative
        in nature. It is advisable to consult a qualified specialist for further
        guidance.
      </div>
    </div>
  );
}
